// Unpublished Work © 2022-2026 Deere & Company.

export const CSV_JOBS_FILENAME = 'Export-Labor-Jobs';
export const CSV_JOBS_HEADERS = [
    {
        key: 'title',
        label: 'Job'
    },
    {
        key: 'jobCategory',
        label: 'Job Category'
    },
    {
        key: 'equipmentArea',
        label: 'Area'
    },
    {
        key: 'estDuration',
        label: 'Estimated Duration'
    },
    {
        key: 'inactive',
        label: 'Inactive'
    },
    {
        key: 'isFavorite',
        label: 'Is Favorite'
    },
    {
        key: 'requiresCutDirections',
        label: 'Requires Cuts And Directions'
    },
    {
        key: 'status',
        label: 'Status'
    }
];
